function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs6"
}, /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "clipPath18"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0,0 H 229.406 V 327.584 H 0 Z",
  id: "path16"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "clipPath30"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0,334.484 H 235.488 V 0 H 0 Z",
  id: "path28"
})));

var SvgSingle = function SvgSingle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    fill: "#000",
    viewBox: "0 0 313.98401 445.97867",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,445.97867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14",
    clipPath: "url(#clipPath18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g20",
    transform: "translate(6.8784,308.7187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -281.598 c 0,-10.601 1.922,-19.287 12.528,-19.287 M 12.797,0 c 0,3.535 2.867,6.398 6.402,6.398 h 185.597 c 3.531,0 6.398,-2.863 6.398,-6.398 v -281.598 c 0,-3.531 -2.867,-6.398 -6.398,-6.398 h -37.422 c -0.844,0.172 -1.715,0.172 -2.559,0 H 19.199 c -3.535,0 -6.402,2.867 -6.402,6.398 z m -0.269,-300.885 192.268,0.088 c 10.601,0 19.199,8.598 19.199,19.199 V 0 c 0,10.601 -8.598,19.199 -19.199,19.199 H 19.199 C 8.593,19.199 0,10.601 0,0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g26",
    clipPath: "url(#clipPath30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g32",
    transform: "translate(37.2119,263.584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 3.531,0 6.398,2.867 6.398,6.402 v 19.2 h 19.199 c 3.535,0 6.403,2.863 6.403,6.398 0,3.535 -2.868,6.402 -6.403,6.402 H 0 c -3.535,0 -6.403,-2.867 -6.403,-6.402 V 6.402 C -6.403,2.867 -3.535,0 0,0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path34"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSingle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/single.62c7dd83.svg";
export { ForwardRef as ReactComponent };